module.exports = __webpack_public_path__ + "static/stripboard_screen-00d428a55e1e94b101a5780d1ba3c413.png";